export default function BillboardLoading() {
  return (
    <div className="row billboard-movie">
      <div className="col-3">
        <div className="billboard-movie-poster" />
      </div>
      <div className="col-9">
        <div className="billboard-movie-header">
          <div className="billboard-movie-title loading" />
          <div className="row">
            <div className="col-md-6">
              <div className="billboard-movie-text loading" />
              <div className="billboard-movie-text loading" />
            </div>
            <div className="col-md-6">
              <div className="billboard-movie-text loading" />
              <div className="billboard-movie-text loading" />
            </div>
          </div>
        </div>
        <div className="billboard-movie-text loading" />
        <div className="billboard-movie-text loading" />
      </div>
    </div>
  );
}
